export default __webpack_public_path__ + "static/media/active3.9aac21ec.svg";